module.exports = __webpack_public_path__ + "img/inst_6.36b0d65c.jpg";